import * as React from 'react';

import {Illustration} from 'shells/illustrations/illustration';

import {FeatureGateModalWrapper} from './feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function ChatEngagementProUpsellModal(props: Props) {
    return (
        <FeatureGateModalWrapper
            isOpen={props.isOpen}
            onClose={props.onClose}
            title='Upgrade to Engagement Pro'
            description='Customize chat, access the omnichannel inbox, and a whole lot more with Nutshell Engagement Pro'
            bullets={[
                'Custom widget icon and remove Nutshell branding from chat, letting you display your brand to customers on your website.',
                'Respond to Facebook, Instagram, and WhatsApp messages in Nutshell.',
                'Access to Nutshell SMS send to manage 1-1 text messages directly from Nutshell, manage inbound SMS requests, and more.',
            ]}
            feature='SMS'
            shouldShowButton={true}
            icon={<Illustration src='chat-engagement-pro-upsell' width={330} />}
        />
    );
}
